import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import * as title from "../../../constants/titles";
import NavigationBarContainer from "../NavigationBarContainer";
import SkiftloggExcel from "./SkiftloggExcel";
import SkiftloggFilterContainer from "./SkiftloggFilterContainer";
import SkiftloggList from "./SkiftloggList";

function SkiftloggPage() {
  const skiftlogger = useSelector((state) => state.skiftlogger) ?? {};
  const skiftloggSubmittedForm = useSelector(
    (state) => state.submittedForms.skiftloggSubmittedForm,
  );

  useEffect(() => {
    document.title = title.rapporter.skiftlogg;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container fluid>
      <Row>
        <Col>
          <NavigationBarContainer page="skiftlogg" />
          <div className="rapportSearch">
            <SkiftloggFilterContainer />
          </div>
          <div className="rapport-buttons-container">
            <SkiftloggExcel
              skiftloggSubmittedForm={skiftloggSubmittedForm}
              skiftlogger={skiftlogger}
            />
            <div className="pull-right" style={{ paddingTop: 20 }}>
              <b>{skiftlogger.list ? skiftlogger.list.length : 0} Rader</b>
            </div>
          </div>
          <div className="clearfix" />
          <div className="rapport-table">
            <SkiftloggList body={skiftlogger} />
          </div>
        </Col>
        <div style={{ height: 30 }} />
      </Row>
    </Container>
  );
}

export default SkiftloggPage;
